//headermenu

const HeaderMenu = $(".js-menu"),
  HeaderSpan1 = $(".js-span1"),
  HeaderSpan2 = $(".js-span2"),
  HeaderSpan3 = $(".js-span3"),
  HeaderNav = $(".js-nav"),
  HeaderSub = $(".js-headsub"),
  windowWidth = $(window).width(),
  windowSm = 1023;

if (windowWidth <= windowSm) {
  HeaderMenu.on("click", function () {
    HeaderMenu.toggleClass("js-menu--close");
    HeaderSpan1.toggleClass("js-span1--close");
    HeaderSpan2.toggleClass("js-span2--close");
    HeaderSpan3.toggleClass("js-span3--close");
    HeaderNav.toggleClass("js-nav--open");
    $("body").toggleClass("js-fixed");
  });

  HeaderSub.on("click", function () {
    let HeadSubCon = $(this).children("ul");
    $(this).toggleClass("js-headsub--open");
    HeadSubCon.slideToggle();
  });
} else {
  HeaderSub.children("ul").hide();

  HeaderSub.on("click", function () {
    let SubNotList = HeaderSub.not($(this)).children("ul");
    let HeadSubCon = $(this).children("ul");
    $(this).toggleClass("js-headsub--open");
    HeadSubCon.slideToggle();
    SubNotList.slideUp(function () {
      $(this).parent(".js-list--open").toggleClass("js-list--open");
    });
  });

  $(window).on("scroll", function () {
    HeaderSub.children("ul").slideUp();
  });
}

const HeaderNavLink = $(".js-nav a[href]");
HeaderNavLink.on("click", function () {
  HeaderMenu.click();
});

$(function () {
  // 実質使われていない可能性あり(この直後にも別のスクロール処理あり)
  var headerHeight = 120;

  $('[href^="#"]').on("click", function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - headerHeight;

    $("html, body").animate(
      {
        scrollTop: position,
      },
      300,
      "linear"
    );
    return false;
  });
});

$(function () {
  var urlHash = location.hash;
  if (urlHash) {
    $("body,html").stop().scrollTop(0);
    setTimeout(function () {
      var headerHight = 120;
      var target = $(urlHash);
      var position = target.offset().top - headerHight;
      $("html, body").animate(
        {
          scrollTop: position,
        },
        300,
        "linear"
      );
      window.history.replaceState(
        null,
        "",
        location.pathname + location.search
      );
      return false;
    });
  }
});

//pagetop
if ($(".js-clinic").length) {
  const Clinic = $(".js-clinic"),
    ClinicCon = $(".js-cliniccon");
  if (windowWidth <= windowSm) {
    ClinicCon.hide();
    Clinic.on("click", function () {
      ClinicCon.slideToggle();
    });
  }
}

// privacy_policy
if (
  $(".p-pagetop__title").is(":contains('プライバシーポリシー')") ||
  $(".p-pagetop__title").is(":contains('Privacy Policy')")
) {
  $(".l-container").addClass("p-privacy_container");
}

// 汎用CSSを適用
if (
  $(".p-pagetop__title").is(":contains('透析お役立ち情報')") ||
  $(".p-pagetop__title").is(":contains('Useful Information on Dialysis')") ||
  $(".p-pagetop__title").is(":contains('治療に関して')") ||
  $(".p-pagetop__title").is(":contains('透析導入前について')") ||
  $(".p-pagetop__title").is(":contains('透析用語集')") ||
  $(".p-pagetop__title").is(":contains('Regarding the treatment')") ||
  $(".p-pagetop__title").is(":contains('サイトマップ')")
) {
  // console.log("test");
  $(".l-container").addClass("p-universal_container");
} else {
  // console.log("test2");
}

//qa
if ($(".p-qa__container").length) {
  const qaDetailcon = $(".js-detailcon"),
    qaDetail = $(".js-detail");
  qaDetailcon.hide();
  qaDetail.on("click", function () {
    qaDetailcon.slideToggle();

    if (qaDetail.text() === "閉じる↓") {
      qaDetail.text("＊参考：人工透析の医療費について");
    } else {
      qaDetail.text("閉じる↓");
    }
  });

  const Question = $(".js-question");
  $(".js-answer").hide();
  Question.click(function () {
    var Answer = $(this).next(".js-answer"),
      AnswerNotOp = Question.not($(this)).next(".js-answer"),
      QuestionTtl = $(this);

    QuestionTtl.toggleClass("js-answer--open");
    Answer.slideToggle();
    AnswerNotOp.slideUp(function () {
      $(this).prev(".js-answer--open").toggleClass("js-answer--open");
    });
  });
}

//url
$(function () {
  $(".js-url").click(function () {
    location.href = $(this).attr("data-url");
  });
});

//lightbox
if ($(".js-lightboxcon").length) {
  const LightBox = $(".js-lightbox"),
    LightBoxMask = $(".js-lightmask");

  LightBox.click(function () {
    let LightBoxCon = $(this).children(".js-lightboxcon");

    LightBoxCon.addClass("js-lightboxcon--open");
    $("main").addClass("js-mainindex");
  });

  LightBoxMask.click(function () {
    let LightMask = $(this).parent();
    LightMask.removeClass("js-lightboxcon--open");
    $("main").removeClass("js-mainindex");
    return false;
  });
}

//recruit list
$(function () {
  $(".p-recruit__text--work:contains('・')").each(function () {
    const el = $(this);
    const elTxt = el.text();
    const replaceTxt = elTxt.replace(/・/g, "<span>・</span>");
    el.wrapInner("<span></span>");
    el.html(replaceTxt);
  });
});

//form confirm
if ($(".mw_wp_form .error").length) {
  $(".js-confirm").css("display", "none");
}

if ($(".mw_wp_form_preview").length) {
  $(".js-confirm").css("display", "none");
  $(".js-confirmpri").css("display", "none");
  if ($(".lng-en").length) {
    $(".p-contact__mailmember > p").text("Subscription to Email");
    $(".p-contact__text").html(
      '<p class="p-contact__text u-tac js-confirmtext">Please confirm the details are correct before submitting.</p>'
    );
    $(".p-recruit__text").html(
      '<p class="p-recruit__text u-normal u-mtmid u-tac js-confirmtext">Please confirm the details are correct before submitting.</p>'
    );
  } else {
    $(".p-contact__mailmember > p").text("メール購読");
    $(".p-contact__text").html(
      '<p class="p-contact__text u-tac js-confirmtext">お間違いないかご確認の上、送信してください。</p>'
    );
    $(".p-recruit__text").html(
      '<p class="p-recruit__text u-normal u-mtmid u-tac js-confirmtext">お間違いないかご確認の上、送信してください。</p>'
    );
  }
}

if ($(".mw_wp_form_complete").length) {
  $(".js-confirm").css("display", "none");
  $(".js-confirmtext").css("display", "none");
  $(".p-contact__text").css("display", "none");
  $(".js-confirmpri").css("display", "none");
  $(".p-recruit__subtitle").css("margin-bottom", "60px");
  if ($(".lng-en").length) {
    $(".mw_wp_form_complete").append(
      '<a class="c-btn" href="/">Return to Top<svg xmlns="http://www.w3.org/2000/svg" width="7.152" height="9.786" viewBox="0 0 7.152 9.786"><path id="Rectangle_2" data-name="Rectangle 2" class="cls-1" d="M1.59,9.893.31,8.357,4.337,5,.31,1.643,1.59.107,7.462,5Z" transform="translate(-0.31 -0.107)"/></svg></a>'
    );
  } else {
    $(".mw_wp_form_complete").append(
      '<a class="c-btn" href="/">TOPへ戻る<svg xmlns="http://www.w3.org/2000/svg" width="7.152" height="9.786" viewBox="0 0 7.152 9.786"><path id="Rectangle_2" data-name="Rectangle 2" class="cls-1" d="M1.59,9.893.31,8.357,4.337,5,.31,1.643,1.59.107,7.462,5Z" transform="translate(-0.31 -0.107)"/></svg></a>'
    );
  }
}

// popup banner
document.addEventListener("DOMContentLoaded", function() {
    // 背景画像遅延読み込み
    const lazyBackgrounds = [].slice.call(document.querySelectorAll('.lazy-bg'));

    if ('IntersectionObserver' in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyBackground = entry.target;
                    lazyBackground.style.backgroundImage = 'url(' + lazyBackground.dataset.bg + ')';
                    lazyBackgroundObserver.unobserve(lazyBackground);
                }
            });
        });
  
        lazyBackgrounds.forEach(function(lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    } else {
        // Fallback for older browsers
        lazyBackgrounds.forEach(function(lazyBackground) {
            lazyBackground.style.backgroundImage = 'url(' + lazyBackground.dataset.bg + ')';
        });
    }

    
    
	const body = document.body;
	const popupOverlay = document.getElementById("js-popup-overlay");
	const closeButton = document.getElementById("js-close-btn");
	const dontShowAgain = document.getElementById("js-dont-show-again");

	// 存在チェック
	if (!popupOverlay || !closeButton || !dontShowAgain) {
			// console.error("Some elements are missing in the HTML.");
			return;
	}

	const initialDelay = 8000; // 最初の表示遅延時間
	const hideDurationAfterClose = 10 * 60 * 1000; // 閉じた後の非表示期間
	// const hideDurationAfterCheck = 7 * 24 * 60 * 60 * 1000; // 一定期間表示しないチェック後の非表示期間
	const hideDurationAfterCheck = 1 * 24 * 60 * 60 * 1000; // 一定期間表示しないチェック後の非表示期間

	function shouldShowPopup() {
			const popupShownTime = localStorage.getItem("popupShownTime");
			const dontShowAgainChecked = localStorage.getItem("dontShowAgainChecked");

			if (!popupShownTime && !dontShowAgainChecked) {
					return true;
			}

			const now = new Date().getTime();
			if (dontShowAgainChecked) {
					return now - parseInt(popupShownTime, 10) > hideDurationAfterCheck;
			} else {
					return now - parseInt(popupShownTime, 10) > hideDurationAfterClose;
			}
	}

	function showPopup() {
			popupOverlay.classList.add("visible");
			body.style.overflow = 'hidden'; // スクロールをロック
	}

	function hidePopup() {
			popupOverlay.classList.remove("visible");
			body.style.overflow = ''; // スクロールを解除
			updateLocalStorage();
	}

	if (shouldShowPopup()) {
			setTimeout(showPopup, initialDelay);
	}

	// 閉じるボタンのイベント
	closeButton.addEventListener("click", hidePopup);

	// 背景クリックのイベント
	popupOverlay.addEventListener("click", function(event) {
			if (event.target === popupOverlay) {
					hidePopup();
			}
	});

	// ローカルストレージの更新
	function updateLocalStorage() {
			const now = new Date().getTime();
			localStorage.setItem("popupShownTime", now.toString());
			if (dontShowAgain.checked) {
					localStorage.setItem("dontShowAgainChecked", "true");
			}
	}


});





// 高速化
(function (d, w) {
  let isInitialized = false;

  const lazyCss = [
    // "https://use.fontawesome.com/releases/v6.2.0/css/all.css?ver=5.8.2",
    "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&family=Lato:wght@700&display=swap",
    "https://use.typekit.net/kjo8kcx.css",
    "https://www.tbt-toseki.jp/wp-includes/css/dist/block-library/style.min.css?ver=6.5.2"
  ];

  const lazyScripts = [
    // "https://cdnjs.cloudflare.com/ajax/libs/iScroll/5.2.0/iscroll.min.js",
  ];

  const lazyTags = [
    // "https://www.googletagmanager.com/gtag/js?id=XXX",
  ];

  let isLoadedCss = false;
  function loadCss() {
    // console.log('loadCSS');
    for (let i = 0, l = lazyCss.length; i < l; i++) {
      const y = d.createElement("link");
      y.rel = "stylesheet";
      y.href = lazyCss[i];
      d.head.appendChild(y);
    }
  }

  let isLoadedJs = false;
  function loadJs() {
    // console.log('loadJs');
    for (let i = 0, l = lazyScripts.length; i < l; i++) {
      const y = d.createElement("script");
      y.async = false;
      y.src = lazyScripts[i];
      d.head.appendChild(y);
    }
  }

  let isLoadedTag = false;
  function loadTag() {
    // console.log('loadTag');
    for (let i = 0, l = lazyTags.length; i < l; i++) {
      const y = d.createElement("script");
      y.async = false;
      y.src = lazyTags[i];
      d.head.appendChild(y);
    }
  }

  function lazyLoadLimit(type) {

    if (isLoadedCss === false && type == "css") {

      isLoadedCss = true;
      w.removeEventListener("scroll", lazyLoadLimit);
      w.removeEventListener("mousemove", lazyLoadLimit);
      w.removeEventListener("mousedown", lazyLoadLimit);
      w.removeEventListener("touchstart", lazyLoadLimit);
      w.removeEventListener("keydown", lazyLoadLimit);
      loadCss();
    }
    if (isLoadedJs === false && type == "js") {
      isLoadedJs = true;
      w.removeEventListener("scroll", lazyLoadLimit);
      w.removeEventListener("mousemove", lazyLoadLimit);
      w.removeEventListener("mousedown", lazyLoadLimit);
      w.removeEventListener("touchstart", lazyLoadLimit);
      w.removeEventListener("keydown", lazyLoadLimit);
      loadJs();
    }
    if (isLoadedTag === false && type == "tag") {
      isLoadedTag = true;
      w.removeEventListener("scroll", lazyLoadLimit);
      w.removeEventListener("mousemove", lazyLoadLimit);
      w.removeEventListener("mousedown", lazyLoadLimit);
      w.removeEventListener("touchstart", lazyLoadLimit);
      w.removeEventListener("keydown", lazyLoadLimit);
      loadTag();
    }
  }

  function lazyLoad() {
    if (isInitialized === false) {
      isInitialized = true;
      w.removeEventListener("scroll", lazyLoad);
      w.removeEventListener("mousemove", lazyLoad);
      w.removeEventListener("mousedown", lazyLoad);
      w.removeEventListener("touchstart", lazyLoad);
      w.removeEventListener("keydown", lazyLoad);
      if (isLoadedCss === false) {
        isLoadedCss = true;
        loadCss();
      }
      if (isLoadedJs === false) {
        isLoadedJs = true;
        loadJs();
      }
      if (isLoadedTag === false) {
        isLoadedTag = true;
        loadTag();
      }
    }
  }
  w.addEventListener("scroll", function () {
    if (w.scrollY) {
      lazyLoad();
    }
  });
  w.addEventListener("mousemove", lazyLoad);
  w.addEventListener("mousedown", lazyLoad);
  w.addEventListener("touchstart", lazyLoad);
  w.addEventListener("keydown", lazyLoad);
  w.addEventListener("load", function () {
    if (w.scrollY) {
      lazyLoad();
    }
  });
  setTimeout(function () {
    lazyLoadLimit("css");
  }, 5000);
  setTimeout(function () {
    lazyLoadLimit("js");
  }, 5000);
  setTimeout(function () {
    lazyLoadLimit("tag");
  }, 2500);
})(document, window);


